//import { createApp } from "https://unpkg.com/vue@3/dist/vue.esm-browser.js"
import { createApp } from "https://cdnjs.cloudflare.com/ajax/libs/vue/3.2.45/vue.esm-browser.prod.min.js"


const productSelector = createApp({
  delimiters: ["${", "}"],
  data() {
      return {
          collection_products: [],
          Hub: [],
          numResults: null,
          Wheel_Size: [],
          Availability: [],
          Intended_Use: [],
          available: false,
          activeMenu: 'Wheel_Size'
      }
  },
  methods: {
      filterProductOption(input) {
          input.disabled = true
          input.parentNode.classList.add("deactive");
          //Find out if collection_products contains this value.
          this.collection_products.forEach(product => {
              let product_options = product.options
              product_options.forEach(option => {
                  let options = Object.values(option)
                  let specificOption = Object.values(options[2])
                  let found = specificOption.includes(input.value)
                  //If TRUE set filter to active. ELSE set to disabled. 
                  if (found == true) {
                      input.disabled = false
                      input.parentNode.classList.remove("deactive");
                  }
              })
          });
      },
      filterProductMetafield(input) {
          input.disabled = true
          input.parentNode.classList.add("deactive");
          this.collection_products.forEach(product => {
              let product_use = product.use
              if (product_use) {
                  product_use.forEach(use => {
                      let found = use.includes(input.value)
                      if (found == true) {
                          input.disabled = false
                          input.parentNode.classList.remove("deactive");
                      }
                  })
              }
          });
      },
      getFilterValues() {
          Object.keys(this.$refs).forEach(el => {
              let input = this.$refs[el];
              if (input.name == 'filter.v.option.hub' || input.name == 'filter.v.option.wheel size') {
                  this.filterProductOption(input)
              } else if (input.name == 'filter.p.m.custom.intended_use') {
                  this.filterProductMetafield(input)
              }
          })
      },
      getFormValues() {
        this.collection_products = [];
        let url = 'https://reservewheels.com/collections/wheels?view=api';
        let marketRoute = window.Shopify.routes.root;
        if (marketRoute != '/') {
            url = 'https://reservewheels.com'+marketRoute+'collections/wheels?view=api';
        } 
          if (this.Availability.length > 0) {
              url = url + '&filter.v.availability=' + this.Availability;
          }

          if (this.Intended_Use.length > 0) {
              url = url + '&filter.p.m.custom.intended_use=' + this.Intended_Use;
          }

          if (this.Hub.length > 0) {
              url = url + '&filter.v.option.hub=' + this.Hub;
          }

          if (this.Wheel_Size.length > 0) {
              url = url + '&filter.v.option.wheel size=' + this.Wheel_Size;
          }

          fetch(url)
              .then((response) => response.json())
              .then((data) => {
                  this.collection_products = data;
                  this.numResults = this.collection_products.length;
                  this.getFilterValues();
              })
              .catch(err => console.error(err))

      },
      getCollection(collections) {
          let category = null;
          collections.forEach((collection) => {
              if (collection.handle.includes("mountain")) {
                  category = "Mountain";
              } else if (collection.handle.includes("gravel")) {
                  category = "Gravel";
              } else if (collection.handle.includes("road")) {
                  category = "Road";
              }
          })
          return category;
      }
  },
  watch: {
      available() {
          if (this.available == true) {
              this.Availability.push('1');
          } else {
              this.Availability = [];
          }
          this.getFormValues();
      },
      Hub() {
          if (this.Hub.includes('Rim Only')) {
              this.Hub.push('Rim Only - 34')
              this.Hub.push('Rim Only - 37')
              this.Hub.push('Rim Only - 40')
              this.Hub.push('Rim Only - 44')
          } else if (!this.Hub.includes('Rim Only')) {
              let hubArr = [];
              hubArr = this.Hub.filter(hub => {
                  if (!hub.includes('Rim Only')) {
                      return hub;
                  }
                  //Set the Hubs to the filtered values from the new Array.
                  this.Hub = hubArr;
              })
          }
      }
  },
  computed: {},
  mounted() {
      this.getFormValues();
  },
})

productSelector.mount("#vue-facet")